import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../translation/translation';

function NoneGiven({ onClick }) {
    return (
        <Translations
            translationKey="catalog-statusbar-mobile-missing-status-none-given"
            className="statusbar-mobile__missing-status statusbar-mobile__missing-status--none-given"
            tagName="div"
            onClick={onClick}
        />
    );
}

NoneGiven.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export { NoneGiven };
